import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { UserService } from './user.service';
import { CartService } from './cart.service';
import { WishlistService } from './wishlist.service';
import { CompareService } from './compare.service';
import { CHAT_PUSH_UNSUBSCRIBE, dropChatPush } from '../api/chat-push';

/// Signing out, in one place: the header's account dropdown, the profile page and the account
/// menu all call this, so none of them can forget a step - it is the steps both older copies took.
/// The session goes, the basket, wish list and compare list are read again as a guest's, and the
/// page reloads, because everything drawn for the signed-in account (the owner's prices, the "view
/// as" country) must be worked out afresh.
@Injectable({
    providedIn: 'root'
})
export class SignOutService {
    private leaving = false;

    constructor(
        private user: UserService,
        private cart: CartService,
        private wishlist: WishlistService,
        private compare: CompareService,
        private router: Router,
        private http: HttpClient,
        @Inject(PLATFORM_ID) private platformId: any,
    ) { }

    signOut(): void {
        if (!isPlatformBrowser(this.platformId)) {
            this.end();
            return;
        }
        if (this.leaving) { return; }
        this.leaving = true;
        // The shop's chat notifications go with the sign-in (FCommerce 5.4): the server forgets this browser while the token
        // still holds, and the browser drops its subscription - else whoever uses it next, or nobody, is shown the shop's
        // messages. Two seconds at most: signing out never waits on the network.
        let ended = false;
        const end = () => { if (!ended) { ended = true; this.end(); } };
        setTimeout(end, 2000);
        dropChatPush(endpoint => this.http.post(environment.apiUrl + CHAT_PUSH_UNSUBSCRIBE, { Endpoint: endpoint }).toPromise()).then(end, end);
    }

    private end(): void {
        this.user.onLogout();
        this.cart.load();
        this.wishlist.load();
        this.compare.load();

        if (isPlatformBrowser(this.platformId)) {
            this.router.navigate(['/']).then(() => {
                window.history.pushState(null, '', window.location.href);
                window.history.back();
                window.history.forward();
            });
            window.location.reload();
        }
    }
}
